import { Component, inject, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Order } from '../../models/order.model';
import { PrintService } from "../../services/print.service";
import { StyleEnum } from "../../enums/style.enum";

@Component({
    selector: 'app-print-order',
    templateUrl: './print-order.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintOrderComponent {
  progress = false;
  selectedType: StyleEnum = StyleEnum.ORDER_PRODUCTS;

  private printService = inject(PrintService);
  orderToPrint: Order | null = null;

  protected readonly StyleEnum = StyleEnum;

  constructor(
    public dialogRef: MatDialogRef<PrintOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public order: Order) {
  }

  /**
   * Close the popup without any actions
   */
  public cancel(): void {
    this.dialogRef.close(null);
  }

  /**
   * Asynchronously prints the given HTML content using the specified print service.
   * @param html - The HTML content to be printed.
   * @returns A promise that resolves when the print operation is completed.
   */
  async print(html): Promise<void> {
    this.printService.print(html, this.selectedType);
    this.orderToPrint = null;
    this.dialogRef.close(null);
  }
}
